export default {
  FWD: 'FWD',
  RWD: 'RWD',
  AWD: 'AWD',
  FourWD: 'FourWD'
}
